import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    target: String,
  };

  scroll(e) {
    e.preventDefault();

    const target = document.querySelector(this.targetValue);

    target.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
